module.exports = __webpack_public_path__ + "img/11.8f2113a6.png";